import L from "leaflet";
import { Constant } from "../../../constant";

export default function LocateButton({ mapRef }) {

  let marker;
  let circle;
  let interval;

  const locateUser = () => {
    const map = mapRef.current.leafletElement;

    map.locate({ setView: true, maxZoom: 16 });

    map.off("locationfound"); // évite duplication

    map.on("locationfound", (e) => {
      // Supprimer anciens éléments
      if (marker) map.removeLayer(marker);
      if (circle) map.removeLayer(circle);
      if (interval) clearInterval(interval);

      // Marker principal
      marker = L.marker(e.latlng)
        .addTo(map)
        .bindPopup("Vous êtes ici")
        .openPopup();

      // Cercle clignotant
      let radius = 10;
      let growing = true;

      circle = L.circleMarker(e.latlng, {
        radius: radius,
        fillColor: Constant.couleur.primary,
        color: Constant.couleur.secondary,
        fillOpacity: 0.3,
      }).addTo(map);

      interval = setInterval(() => {
        if (growing) {
          radius += 2;
          if (radius > 30) growing = false;
        } else {
          radius -= 2;
          if (radius < 10) growing = true;
        }

        circle.setRadius(radius);
      }, 100);
    });
  };

  return (
    <button
      onClick={locateUser}
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 1000,
      }}
    >
      📍 My location
    </button>
  );
}